jQuery.feature_import("js-unitadminpage",
  () => import("./Unit-AdminPage.js"),
  mod => mod.feature_js_unitadminpage
);